var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading84_container"},[_c('div',{staticClass:"loader"})])
}]

export { render, staticRenderFns }